<script lang="ts" setup>
defineProps({
  searchPage: {
    type: Boolean,
    required: false,
    default: false,
  },
  hideAdvancedSearch: {
    type: Boolean,
    required: false,
    default: false,
  },
  sidney: {
    type: Boolean,
    required: false,
    default: false,
  },
  inHome: {
    type: Boolean,
    required: false,
    default: false,
  },
})

const route = useRoute()
</script>
<template>
  <div>
    <SearchForm :inHome="inHome" :sidney="sidney ||
      route.query.collection === 'work_versions' ||
      route.path.includes('/sidney/')
      " :hideAdvancedSearch="hideAdvancedSearch" />
  </div>
</template>
